// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFiltering.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Cross Filtering Component
 */

import React, { PropTypes } from 'react';
import { propTypes as MobxPropTypes } from 'mobx-react';
import connect from 'share/enhancers/Izenda.Connect';
import CrossFilteringOption from './Izenda.CrossFilteringOption';
import CrossFilteringSlider from './Izenda.CrossFilteringSlider';
import Button from 'share/components/controls/Izenda.Button';
import actions from './Izenda.CrossFilteringActions';

const propTypes = {
  localization: PropTypes.object,
  crossFilteringDetail: MobxPropTypes.arrayOrObservableArray.isRequired,
  showCrossFilteringOption: PropTypes.bool,
  removeCrossFiltering: PropTypes.func.isRequired,
  removeAllCrossFiltering: PropTypes.func.isRequired,
  onCrossFilteringOptionClick: PropTypes.func,
  hadSetting: PropTypes.bool,
  resetDefaultValue: PropTypes.func,
  enableCrossFilteringOption: PropTypes.bool,
  enableDeleteAll: PropTypes.bool
};

const CrossFiltering = connect(actions)(({
  localization,
  onCrossFilteringOptionClick,
  resetDefaultValue,
  hadSetting,
  showCrossFilteringOption,
  crossFilteringDetail,
  enableCrossFilteringOption,
  enableDeleteAll,
  onRemoveAllCrossFiltering,
  onRemoveCrossFiltering
}) => {
  return (
    <div className='u_table izenda-CrossFiltering u_paddingLeft'>
      {showCrossFilteringOption && <div className='izenda-CrossFiltering_FilterOptions'>
        <CrossFilteringOption
          onOptionClick={onCrossFilteringOptionClick}
          hadSetting={hadSetting}
          resetDefaultValue={resetDefaultValue}
          localization={localization}
          enable={enableCrossFilteringOption} />
      </div>}
      <div className='izenda-CrossFiltering__SliderContainer'>
        <CrossFilteringSlider
          crossFilteringDetail={crossFilteringDetail}
          removeCrossFiltering={onRemoveCrossFiltering}
          localization={localization} />
      </div>
      <div className='izenda-CrossFiltering__removeAllCrossFilteringItemContainer'>
        <Button className='icon-trash-empty icon-removeAllCrossFilteringItem u_noPaddingAll u_noBorder'
          title={localization.getText('CROSSFILTERING_REMOVE_ALL_TOOLTIP')}
          disabled={!enableDeleteAll}
          onClick={onRemoveAllCrossFiltering} />
      </div>
    </div>
  );
});

CrossFiltering.propTypes = propTypes;

export default CrossFiltering;


// WEBPACK FOOTER //
// ./ui/modules/CrossFiltering/Izenda.CrossFiltering.js